<template>
    <v-container fluid fill-height style="padding:0px 10px 5px 10px;width:100%;height:100%;">
        <v-layout column>
            <v-flex>
                <div class="slides" style="width: 92vw !important;" v-on:scroll="onSlideScroll">
                    <div v-for="cd in cardData" :key="cd" class="slide">
                        <v-layout fill-height style="overflow:auto;">
                            <EngineCard :cardData="cd"></EngineCard>
                        </v-layout>
                    </div>
                </div>
                <v-layout row v-if="cardData.length > 1" style="padding-top: 5px;">
                    <div style="width: 50%; text-align: center;">
                        <a class="slider-arrows scroll-back disabled" href="#" @click="slideBackward">
                            <i class="material-icons">chevron_left</i>
                        </a>
                    </div>
                    <div style="width: 50%; text-align: center;">
                        <a class="slider-arrows scroll-forward" href="#" @click="slideForward">
                            <i class="material-icons">chevron_right</i>
                        </a>
                    </div>
                </v-layout>
            </v-flex>
            <v-flex>
                <v-card>
                    <v-tabs :ref="ticketList" v-model="tabActive" slider-color="rgb(144,170,218)" style="height:100%;width:100%;">
                        <v-tab v-for="title in tabTitles" :key="title" ripple active-class='activeTab' style="text-transform:none;color:rgb(192,192,192);"><span>{{title}}</span></v-tab>
                        <v-tab-item class="tabItem">
                            <OpenTickets :tickets="open_tickets"/>
                        </v-tab-item>
                        <v-tab-item class="tabItem">
                            <ClosedTickets :tickets="close_tickets"/>
                        </v-tab-item>
                    </v-tabs>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import OpenTickets from "./OpenTickets"
    import ClosedTickets from "./ClosedTickets"
    import EngineCard from '../components/EngineCard'
    import {store} from "../main.js";

    export default {
        name: "CompanyView",
        components: {
            EngineCard,
            OpenTickets,
            ClosedTickets
        },
        data() {
            return {
                tabActive: 0,
                cardData: [],
                tabTitles: [
                    'Open Tickets', 'Closed Tickets'
                ],
                open_tickets: [],
                close_tickets: [],
            }
        },
        props: {
            active: Boolean,
            companyData: Object
        },
        computed: {
            selectedTicketsVessel: function () {
                return store.selectedTicketsVessel;
            }
        },
        created() {
        },
        mounted() {
            this.setData();
        },
        methods: {
            slideBackward(event) {
                var parentElement = event.target.parentElement.parentElement.parentElement.parentElement,
                    slider = parentElement.querySelectorAll('.slides')[0],
                    slide = slider.querySelectorAll('.slide')[0];

                slider.scrollLeft -= slide.getBoundingClientRect().width;
            },
            slideForward(event) {
                var parentElement = event.target.parentElement.parentElement.parentElement.parentElement,
                    slider = parentElement.querySelectorAll('.slides')[0],
                    slide = slider.querySelectorAll('.slide')[0];

                slider.scrollLeft += slide.getBoundingClientRect().width;
            },
            onSlideScroll(event) {
                var slider = event.target,
                    slides = slider.querySelectorAll('.slide'),
                    scroll_back = event.target.parentElement.querySelector('.scroll-back'),
                    scroll_forward = event.target.parentElement.querySelector('.scroll-forward');

                scroll_back.classList.remove('disabled');
                scroll_forward.classList.remove('disabled');

                if (slider.scrollLeft == 0) {
                    scroll_back.classList.add('disabled');
                } else if (slider.scrollLeft >= (slider.clientWidth * (slides.length - 1))) {
                    scroll_forward.classList.add('disabled');
                }
            },
            setData() {
                this.cardData = [];

                if (typeof this.companyData.vessels != 'undefined') {
                    let vessels = Object.keys(this.companyData.vessels);

                    for (let i = 0; i < vessels.length; i++) {
                        let vessName = vessels[i],
                            engType = this.companyData.vessels[vessName].engineType,
                            engines = Object.keys(this.companyData.vessels[vessName].engines);

                        for (let e = 0; e < engines.length; e++) {
                            let bsfcData = {
                                    title: 'SFOC',
                                    unit: 'g/kWh',
                                    value: this.companyData.vessels[vessName].engines[engines[e]].bsfc,
                                    format: 1,
                                    chartOptions: {
                                        time: {
                                            useUTC: false
                                        },
                                        chart: {backgroundColor: 'transparent'},
                                        tooltip: {
                                            formatter: function () {
                                                return this.points.reduce(function (s, point) {
                                                    return s + '<br/>' + point.series.name + ': ' + point.y.toFixed(2);
                                                    //}, '<b>' + this.x + '</b>');
                                                }, '<b>' + new Date(this.x).toTimeString().substring(0, 5) + '</b>');
                                            },
                                            shared: true
                                        },
                                        legend: {
                                            enabled: false
                                        },
                                        title: {text: undefined},
                                        xAxis: {
                                            type: 'datetime',
                                            labels: {enabled: false},
                                            crosshair: true
                                        },
                                        yAxis: {
                                            labels: {enabled: false},
                                            title: {text: undefined}
                                        },
                                        exporting: {
                                            enabled: false
                                        },
                                        series: [
                                            {
                                                name: 'Values',
                                                type: 'line',
                                                data: [],
                                                marker: {
                                                    enabled: false
                                                },
                                                states: {
                                                    hover: {
                                                        enabled: false
                                                    },
                                                    normal: {
                                                        animation: false
                                                    },
                                                    inactive: {
                                                        opacity: 1
                                                    }
                                                }
                                            }, {
                                                name: 'Ref',
                                                type: 'line',
                                                data: [],
                                                marker: {
                                                    enabled: false
                                                },
                                                states: {
                                                    hover: {
                                                        enabled: false
                                                    },
                                                    normal: {
                                                        animation: false
                                                    },
                                                    inactive: {
                                                        opacity: 1
                                                    }
                                                }
                                            }
                                        ]
                                    }
                                },
                                slocData = {
                                    title: 'SLOC setting',
                                    unit: 'g/kWh',
                                    value: this.companyData.vessels[vessName].engines[engines[e]].sloc,
                                    format: 1,
                                    chartOptions: {
                                        chart: {backgroundColor: 'transparent'},
                                        tooltip: {
                                            formatter: function () {
                                                return this.points.reduce(function (s, point) {
                                                    return s + '<br/>' + point.series.name + ': ' + point.y.toFixed(2);
                                                }, '<b>' + new Date(this.x).toTimeString().substring(0, 5) + '</b>');
                                            },
                                            shared: true
                                        },
                                        legend: {
                                            enabled: false
                                        },
                                        title: {text: undefined},
                                        xAxis: {
                                            labels: {enabled: false},
                                            crosshair: true
                                        },
                                        yAxis: {
                                            labels: {enabled: false},
                                            title: {text: undefined}
                                        },
                                        exporting: {
                                            enabled: false
                                        },
                                        series: [
                                            {
                                                name: 'Values',
                                                type: 'line',
                                                data: [],
                                                marker: {
                                                    enabled: false
                                                },
                                                states: {
                                                    hover: {
                                                        enabled: false
                                                    },
                                                    normal: {
                                                        animation: false
                                                    },
                                                    inactive: {
                                                        opacity: 1
                                                    }
                                                }
                                            }
                                        ]
                                    }
                                },
                                faultData = {},
                                ticketData = [],
                                kpi = Math.round(this.companyData.vessels[vessName].engines[engines[e]].eng_KPI * 100),
                                color = this.companyData.vessels[vessName].engines[engines[e]].eng_KPI_color;

                            for (let j = 0; j < 96; j++) {
                                bsfcData.chartOptions.series[0].data.push([j, (Math.random() * 2) - 1 + bsfcData.value]);
                            }

                            for (let j = 0; j < 96; j++) {
                                slocData.chartOptions.series[0].data.push([j, (Math.random() * 0.2) - 0.1 + slocData.value]);
                            }

                            if (Object.keys(this.companyData.vessels[vessName].engines[engines[e]]).includes('lastFault')) {
                                faultData.last = this.companyData.vessels[vessName].engines[engines[e]]['lastFault'];
                            }

                            for (let j = 0; j < 24; j++) {
                                ticketData.push({});
                            }

                            this.cardData.push({
                                name: engType,
                                lastUpdate: new Date().toISOString().slice(0, 10),
                                vessel: vessName,
                                engineKPI: kpi,
                                engineColor: color,
                                fault: faultData,
                                bsfc: bsfcData,
                                sloc: slocData,
                                tickets: ticketData
                            });
                        }
                    }
                }
            }
        },
        watch: {
            companyData: function () {
                this.setData();
            },
            selectedTicketsVessel: function () {
                if (store.selectedTicketsVessel.length) {
                    this.open_tickets = store.vesselTickets[store.selectedTicketsVessel].open;
                    this.close_tickets = store.vesselTickets[store.selectedTicketsVessel].resolved;
                } else {
                    this.open_tickets = [];
                    this.close_tickets = [];
                }
            }
        }
    }
</script>

<style scoped>
    .tabItem {
        height: initial;
    }

    .slides {
        display: -webkit-box;
        display: flex;

        overflow-x: auto;
        -ms-scroll-snap-type: x mandatory;
        scroll-snap-type: x mandatory;

        scroll-behavior: smooth;
        -webkit-overflow-scrolling: touch;
    }

    .slides > div {
        width: 100%;
        scroll-snap-align: start;
        flex-shrink: 0;
        -webkit-transform-origin: center center;
        transform-origin: center center;
        -webkit-transform: scale(1);
        transform: scale(1);
        -webkit-transition: -webkit-transform 0.5s;
        transition: -webkit-transform 0.5s;
        transition: transform 0.5s;
        transition: transform 0.5s, -webkit-transform 0.5s;
        position: relative;

        display: -webkit-box;

        display: flex;
        -webkit-box-pack: center;
        justify-content: center;
        -webkit-box-align: center;
        align-items: center;
    }

    .slider-arrows.disabled {
        color: lightgray;
    }
</style>

<style>
    .activeTab {
        color: rgb(144, 170, 218) !important;
        opacity: 1 !important;
    }
</style>
